import { MijnRoute } from '../mijn-navigatie.model';

export const EXTERNE_BETALING: MijnRoute = {
    path: 'externe-betaling',
    navigationEvent: 'toExterneBetaling',
    regex: /^\/externe-betaling$/,
    webcomponent: 'mijn-externe-betaling-webcomponent'
};
